import type { PlayerTrack } from '@/components/player/PlayerProvider'

interface SongLike {
  id: string
  title: string
  artists: string[]
  album_image_url: string | null
}

export const songKey = (songId: string) => `song:${songId}`

// A song that's in the catalog: previewed by its id.
export function songTrack(song: SongLike): PlayerTrack {
  return {
    key: songKey(song.id),
    title: song.title,
    artist: song.artists.join(', '),
    imageUrl: song.album_image_url,
    previewPath: `/api/songs/${encodeURIComponent(song.id)}/preview`,
  }
}

// A track we only know from Last.fm's canon (an "essential" the instructor
// doesn't play yet): previewed by artist + title.
export function lookupTrack(artist: string, title: string): PlayerTrack {
  const query = new URLSearchParams({ artist, title })
  return { key: `lookup:${artist}|${title}`, title, artist, imageUrl: null, previewPath: `/api/previews?${query}` }
}
